<template>
  <div class="rightItem-container">
    <div class="item-wrapper borderTop">
      <div class="item-date">{{ date | dateFormat('Lllmm')}}</div>
      <div class="item-content">
        <img class="content-img" :src="img" />
        <div class="content-info">
          <div class="info-title">{{ title }}</div>
          <div class="info-card" v-if="code && code.length > 0">
            <div class="card-name" :class="{ noLen : code.length >= 20 }">兑换码：</div>
            <div class="card-no" :class="{ noLen : code.length >= 20 }">{{ code }}</div>
            <div class="card-copy" @click="copy(code)">复制</div>
          </div>
          <div class="info-card" v-if="account && account.length > 0">
            <div class="card-name" :class="{ noLen : account.length >= 20 }">卡号：</div>
            <div class="card-no" :class="{ noLen : account.length >= 20 }">{{ account }}</div>
            <div class="card-copy" @click="copy(account)">复制</div>
          </div>
          <div class="info-card" v-if="pwd && pwd.length > 0">
            <div class="card-name">卡密：</div>
            <div class="card-no">{{ pwd }}</div>
            <div class="card-copy" @click="copy(pwd)">复制</div>
          </div>
          <div class="info-exchange" v-if="link && link.length > 0" @click="gotoExchange">去兑换 ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@common/js/mixin';

export default {
    name: 'rightItem',
    mixins: [mixin],
    props: {
        date: Number,
        title: String,
        code: String,
        account: String,
        pwd: String,
        img: String,
        link: String
    },
    data() {
        return {};
    },
    methods: {
        copy(val) {
            let score = localStorage.getItem('KUserTotalScore')
            this.POINT('h5_clk', {
                page: 'super-普惠权益领取记录页',
                tgt_event_id: 'h5_ACT_inclusive_record',
                tgt_name: 'h5-ACT-普惠权益领取记录页',
                param: `'当前活力值：'${score ? score : '0未激活'}`,
                param1: '按钮名称：复制'
            });
            this.$copyText(val).then(() => {
                this.$toast({ message: '复制成功', duration: 2000 });
            }, () => {
                this.$toast({ message: '复制失败', duration: 2000 });
            });
        },
        gotoExchange() {
            let score = localStorage.getItem('KUserTotalScore')
            this.POINT('h5_clk', {
                page: 'super-普惠权益领取记录页',
                tgt_event_id: 'h5_ACT_inclusive_record',
                tgt_name: 'h5-ACT-普惠权益领取记录页',
                param: `'当前活力值：'${score ? score : '0未激活'}`,
                param1: '按钮名称：去兑换'
            });
            this.openLink(this.link);
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../../common/style/borderLine.scss';
.rightItem-container {
  width: 100%;
  min-height: 122px;
  background: #ffffff;
  @include border-line-style(#F5F8FA);
  .item-wrapper {
    padding: 12px 24px 17px 18px;
    .item-date {
      font-size:12px;
      // font-family:fzlt;
      font-weight:normal;
      color:rgba(159,170,181,1);
      line-height:12px;
    }
    .item-content {
      display: flex;
      display: -webkit-flex;
      margin-top: 18px;
      overflow: hidden;
      .content-img {
        width: 62px;
        height: 38.53px;
        flex-grow: 0;
        flex-shrink: 0;
        border-radius: 4px;
      }
      .content-info {
        padding-left: 20px;
        flex: 1;
        overflow: hidden;
        .info-title {
          margin-right: 91px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow-ellipsis: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          font-size:15px;
          // font-family:fzlt;
          font-weight:normal;
          color:rgba(0,42,60,1);
          line-height: 17px;
        }
        .info-card {
          margin-top: 12px;
          font-size:12px;
          // font-family:fzlt;
          font-weight:normal;
          color:rgba(73,89,108,1);
          display: flex;
          display: -webkit-flex;
          .noLen {
            line-height: 18px;
          }
          .card-name {
            flex-grow: 0;
            flex-shrink: 0;
            line-height: 14px;
          }
          .card-no {
            flex: 1;
            margin-right: 36px;
            overflow: hidden;
            word-wrap: break-word;
            display: -webkit-box;
            text-overflow-ellipsis: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-height: 14px;
            &.noLen {
              line-height: 18px;
            }
          }
          .card-copy {
            width:32px;
            height:14px;
            background:rgba(247,247,247,1);
            border-radius:7px;
            flex-grow: 0;
            flex-shrink: 0;
            font-size:10px;
            // font-family:fzlt;
            font-weight:normal;
            color:rgba(37,77,94,1);
            line-height: 14px;
            text-align: center;
          }
        }
        .info-exchange {
          margin-top: 12px;
          font-size:12px;
          // font-family:fzlt;
          font-weight:normal;
          color:rgba(207,143,68,1);
          line-height:12px;

        }
      }
    }
  }
}
</style>
